import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { bookingUrl } from '../data/site';
export function BookingBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.9);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-17" data-mp="3nkuttb495fwo">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 border-t border-sand-dark/50 bg-ivory/95 px-4 py-3 backdrop-blur-md sm:hidden" initial={{
      y: 80
    }} animate={{
      y: 0
    }} exit={{
      y: 80
    }} transition={{
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1]
    }} data-id="element-18" data-mp="3njtfmxrxwdaq">
          <div className="flex items-center justify-between gap-4" data-id="element-19" data-mp="39kk2y82y01bi">
            <div data-id="element-20" data-mp="34lqmc6sczu74">
              <p className="font-serif text-lg leading-none text-forest-deep" data-id="element-21" data-mp="34nbiu1y8hn7m">
                Your home in Taveuni
              </p>
              <p className="mt-1 text-[11px] uppercase tracking-[0.14em] text-forest-deep/50" data-id="element-22" data-mp="gcbdxtl0xwry">
                Breakfast included
              </p>
            </div>
            <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="rounded-full bg-ocean px-6 py-3.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-ivory" data-id="element-23" data-mp="7f0xzux9hjgp">
              Book
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}